import React from 'react';

import { Spinner } from '@lightspeed/flame/Spinner';
import cn from 'classnames';

const Loading = ({ className = '' }) => (
  <div className={cn('react-page__spinner', className)} data-test="loading">
    <Spinner size="2rem" color="gray-300" />
  </div>
);

export default Loading;
